import { NodeEntity } from './node.types';

export type TripType = 'direct' | 'first_mile' | 'last_mile' | 'transfer' | 'return_pickup' | 'return_delivery';
export type TripStatus = 'planned' | 'pending' | 'assigned' | 'in_transit' | 'arrived' | 'completed' | 'failed' | 'cancelled' | 'picked_up' | 'arrived_at_hub' | 'out_for_delivery' | 'at_customer';
export type DiscrepancyReason = 'not_picked_up' | 'lost' | 'damaged' | 'mis_routed' | 'wrong_destination';

export interface Trip {
  id: string;
  trip_number?: string | null;
  shipment_id: string;
  sequence: number;
  trip_type: TripType;
  from_node_id?: string;
  from_node?: NodeEntity | string | null;
  to_node_id?: string;
  to_node?: NodeEntity | string | null;
  carrier_id?: string;
  driver_id?: string;
  driver?: { id: string; name: string; phone: string };
  manifest_id?: string;
  status: TripStatus;
  cost?: number;
  driver_fee?: number;
  actual_departure_at?: string;
  actual_arrival_at?: string;
  failure_reason?: string;
  discrepancy_reason?: DiscrepancyReason;
  discrepancy_notes?: string;
  discrepancy_reported_at?: string;
  created_at: string;
  attempt_number?: number;
  previous_attempt_trip_id?: string | null;
  // Flat fields returned by list API
  tracking_number?: string | null;
  driver_name?: string | null;
  driver_phone?: string | null;
  manifest_number?: string | null;
  manifest_status?: string | null;
}

export const TRIP_TYPE_LABELS: Record<TripType, string> = {
  direct: 'توصيل مباشر',
  first_mile: 'الميل الأول',
  last_mile: 'الميل الأخير',
  transfer: 'نقل بين المراكز',
  return_pickup: 'استلام مرتجع',
  return_delivery: 'إرجاع للمرسل',
};

export const TRIP_STATUS_LABELS: Record<TripStatus, string> = {
  planned:          'مخطط',
  pending:          'قيد الانتظار',
  assigned:         'معين',
  picked_up:        'تم الاستلام',
  in_transit:       'قيد التنفيذ',
  arrived:          'وصل',
  arrived_at_hub:   'وصل المركز',
  out_for_delivery: 'خرج للتوصيل',
  at_customer:      'عند العميل',
  completed:        'مكتمل',
  failed:           'فشل',
  cancelled:        'ملغى',
};

export const MANIFEST_STATUS_LABELS: Record<string, string> = {
  draft:                'مسودة',
  confirmed:            'مؤكد',
  assigned:             'معين',
  accepted:             'مقبول',
  in_progress:          'قيد التنفيذ',
  completed:            'مكتمل',
  partially_completed:  'مكتمل جزئياً',
  cancelled:            'ملغى',
};

export const DISCREPANCY_REASON_LABELS: Record<DiscrepancyReason, string> = {
  not_picked_up: 'لم يتم استلامها من المرسل',
  lost: 'مفقودة',
  damaged: 'تالفة',
  mis_routed: 'تم توجيهها بشكل خاطئ',
  wrong_destination: 'وجهة خاطئة',
};
